import { LegacyBaseApiService } from '@smartera/core';
import { Urls } from '@core/config/urls';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';

@Injectable()
export class ApplicationDefinitionService extends LegacyBaseApiService<any> {
	override get apiUrl() {
		return Urls.BASE_URL.toString() + '/sec/application-definitions';
	}

	public getApplicationIds(): Observable<any> {
		return this.findListObjects();
	}
}
